import React, { useState,useEffect, useCallback } from 'react'
import './login.css'
import { getToken, loginWithToken } from '../api/loginChat'

import store from '../redux/store'
import { setMyUserInfo } from '../redux/actions'
import { useParams } from 'react-router-dom/cjs/react-router-dom.min';
import loader from '../assets/loader.svg'
import { BACKEND_URL } from '../utils/constant'
export default function Login() {
    const [notice, setNotice] = useState({
        show: false,
        text: ''
    })
    const token = localStorage.getItem('token')
    const [values, setValues] = useState({
        agoraId: '',
        nickName: '',
        password: '',
        showPassword: false
    });
    
     

    const login = useCallback((agoraId , password) => {
            getToken(agoraId, password).then((res) => {
                const { access_token, user:{uuid} } = res
                loginWithToken(agoraId.toLowerCase(), access_token).then(value => {
                }).catch(err => {
                    console.log(err)
                    setNotice({ show: true, text: 'Wrong Username or Password' })
                }).finally(_ => {
                   
                })
                
                store.dispatch(setMyUserInfo({ agoraId: agoraId, password: password}))
                sessionStorage.setItem('webim_auth', JSON.stringify({ agoraId: agoraId, password: password, accessToken: access_token, agoraUid :uuid }))
            }).catch(() => {
                // store.dispatch(setFetchingStatus(false))
                setNotice({ show: true, text: 'login fail' })
                // message.error('login fail.')
            })
    }, [values])

    const getUserProfile = async () => {
       try {
        const res = await fetch(`${BACKEND_URL}user/profile-details` ,{
            headers:{
                'Authorization': `Bearer ${token}`
            }
        })
        const data = await res.json()
        return data.data.username
       } catch (error) {
         window.location.href = '/'
       }
    }

    useEffect(async() => {
        if (token) {
            const username = await getUserProfile()
            login(username, '12345678')
        }
    }, [token])


    useEffect(() => {
        const webim_auth = JSON.parse(sessionStorage.getItem('webim_auth'))
        if (webim_auth && webim_auth.password) {
            setValues({
                agoraId: webim_auth.agoraId || '',
                nickName: webim_auth.nickName || '',
                password: webim_auth.password || '',
            })
        } else {
            sessionStorage.removeItem('webim_auth')
        }
    }, [])
  
    
   
    return (
        <div className={`loader_img_main`}>
        <div className='loader_img_wpr'>
            <img src={loader} alt='' />
        </div>
    </div>
    )
}


